module.exports = __webpack_public_path__ + "static/media/kirby_0.8407893a.png";